export default __webpack_public_path__ + "static/media/TypewriterTipTip.0da32ec2.png";